(function () {
  function initBestsellers(root) {
    var sections = root.querySelectorAll ? root.querySelectorAll('[data-cb-tabs]') : [];

    Array.prototype.forEach.call(sections, function (section) {
      if (section.getAttribute('data-cb-tabs-ready') === 'true') return;
      section.setAttribute('data-cb-tabs-ready', 'true');

      var tabs = section.querySelectorAll('[role="tab"]');
      var panels = section.querySelectorAll('[role="tabpanel"]');

      Array.prototype.forEach.call(tabs, function (tab) {
        tab.addEventListener('click', function () {
          var targetId = tab.getAttribute('aria-controls');

          Array.prototype.forEach.call(tabs, function (item) {
            var isActive = item === tab;
            item.setAttribute('aria-selected', isActive ? 'true' : 'false');
            item.setAttribute('tabindex', isActive ? '0' : '-1');
          });

          Array.prototype.forEach.call(panels, function (panel) {
            panel.hidden = panel.id !== targetId;
          });
        });

        tab.addEventListener('keydown', function (event) {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();

          var currentIndex = Array.prototype.indexOf.call(tabs, tab);
          var direction = event.key === 'ArrowRight' ? 1 : -1;
          var nextIndex = (currentIndex + direction + tabs.length) % tabs.length;
          tabs[nextIndex].focus();
          tabs[nextIndex].click();
        });
      });
    });
  }

  function start() {
    initBestsellers(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initBestsellers(event.target);
  });
})();
